var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('px-lista-relatorios-especificos',{attrs:{"relatorios":_vm.relatorios,"loading":_vm.loading,"on-change-options":_vm.onChangeOptions,"options-list":_vm.optionsList},on:{"update":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }